import React from 'react';

import Image_1 from '../../assets/stripe-create-account_1.png';
import Image_10 from '../../assets/stripe-create-account_10.png';
import Image_2 from '../../assets/stripe-create-account_2.png';
import Image_3 from '../../assets/stripe-create-account_3.png';
import Image_4 from '../../assets/stripe-create-account_4.png';
import Image_5 from '../../assets/stripe-create-account_5.png';
import Image_6 from '../../assets/stripe-create-account_6.png';
import Image_7 from '../../assets/stripe-create-account_7.png';
import Image_8 from '../../assets/stripe-create-account_8.png';
import Image_9 from '../../assets/stripe-create-account_9.png';

import { Loader } from '@/components/Common';
import { paths } from '@/config';
import { Link } from 'react-router-dom';
import { useHowToSalesAccountHooks } from '../../hooks';
import { CopyArea } from './copy-area';
import './style.scss';

const core = () => {
  const {
    data,
    isLoading,
    handleWebSiteCopy,
    website,
    clipboard,
    isError,
  } = useHowToSalesAccountHooks();

  return (
    <div className="a__introduction_howto_sales_account">
      <div className="w__introduction_howto_sales_account">
        <header>Stripeの登録方法について</header>
        <div className="introduction_howto_sales_account-warning">
          <p>
            正しく項目が登録ができていないことが原因で、Stripeの審査がとおらず、売上金が入金されない事例が多発しています。
            <br />
            必ず、下記の手順と入力項目をご確認の上、登録してください。
          </p>
        </div>
        <div className="introduction_howto_sales_account-warning">
          <p>
            審査が通らず追加資料を求められた場合、
            <Link to={paths.introduction.faq}>こちら</Link>
            のページをご確認ください
          </p>
        </div>
        <div className="explain">
          FishSale以外でStripeを活用しない場合には、設問に対して次のとおり回答してください。
          <br />
          FishSale以外でもご利用される場合には、設問に従いご回答ください。
        </div>
        <div className="answer_example">
          <p className="introduction_howto_sales_account--step">STEP1</p>
          <a href={Image_1} target="_blank" rel="noopener noreferrer">
            <img src={Image_1} loading="lazy" decoding="async" />
          </a>
          <p className="introduction_howto_sales_account--step">STEP2</p>
          <a href={Image_2} target="_blank" rel="noopener noreferrer">
            <img src={Image_2} loading="lazy" decoding="async" />
          </a>
          <p className="introduction_howto_sales_account--step">STEP3</p>
          <a href={Image_3} target="_blank" rel="noopener noreferrer">
            <img src={Image_3} loading="lazy" decoding="async" />
          </a>
          <p className="introduction_howto_sales_account--step">STEP4</p>
          <a href={Image_4} target="_blank" rel="noopener noreferrer">
            <img src={Image_4} loading="lazy" decoding="async" />
          </a>
          <p className="introduction_howto_sales_account--step">STEP5</p>
          <a href={Image_5} target="_blank" rel="noopener noreferrer">
            <img src={Image_5} loading="lazy" decoding="async" />
          </a>
          <p className="introduction_howto_sales_account--step">STEP6</p>
          <p>
            「ビジネスのWEBサイト」にはユーザーページを下記よりコピーし入力してください。
          </p>
          {window.isAuthed && !isLoading && data && (
            <div className="introduction_howto_sales_account--copy">
              <label>
                <span className="textbox-label">ビジネスのWebサイト</span>
                <input
                  type="text"
                  className="textbox"
                  value={website}
                  onClick={handleWebSiteCopy}
                  readOnly
                />
              </label>
              <p className="description">クリックするとコピーされます。</p>
              {clipboard.copied && <p className="balloon">コピーしました</p>}
            </div>
          )}
          {isLoading && window.isAuthed && (
            <div className="introduction_howto_sales_account--loader">
              <Loader />
            </div>
          )}
          {!window.isAuthed && (
            <p className="introduction_howto_sales_account-warning">
              ユーザーページを取得するために、
              <a href={paths.before.signin}>ログイン</a>してください
            </p>
          )}
          {window.isAuthed && isError && (
            <p className="introduction_howto_sales_account-warning">
              読み込みに失敗しました。ページを再度読み込んでください。
            </p>
          )}
          <a href={Image_6} target="_blank" rel="noopener noreferrer">
            <img src={Image_6} loading="lazy" decoding="async" />
          </a>
          <CopyArea label="商品、サービス内等の詳細" mb={49}>
            釣った魚をその場で出品して、ほしい時にほしい人に届ける魚専門セリアプリです
          </CopyArea>

          <p className="introduction_howto_sales_account--step">STEP7</p>
          <a href={Image_7} target="_blank" rel="noopener noreferrer">
            <img src={Image_7} loading="lazy" decoding="async" />
          </a>
          <p className="introduction_howto_sales_account--step">STEP8</p>
          <a href={Image_8} target="_blank" rel="noopener noreferrer">
            <img src={Image_8} loading="lazy" decoding="async" />
          </a>
          <p className="introduction_howto_sales_account--step">STEP9</p>
          <a href={Image_9} target="_blank" rel="noopener noreferrer">
            <img src={Image_9} loading="lazy" decoding="async" />
          </a>
          <CopyArea label="店舗名・サービス名">FishSale</CopyArea>
          <CopyArea>フィッシュセール</CopyArea>
          <CopyArea mb={16}>FISHSALE.JP</CopyArea>

          <CopyArea label="短い表記">FishSale</CopyArea>
          <CopyArea>フィッシュセール</CopyArea>
          <CopyArea mb={16}>FISHSALE</CopyArea>

          <CopyArea mb={40} label="お客様問合せ電話番号">
            05053576320
          </CopyArea>

          <p className="introduction_howto_sales_account--step">STEP10</p>
          <a href={Image_10} target="_blank" rel="noopener noreferrer">
            <img src={Image_10} loading="lazy" decoding="async" />
          </a>
          {/* <img
            src="https://fishsale.jp/assets/stripe-create-account.png"
            loading="lazy"
            decoding="async"
          /> */}
        </div>
      </div>
    </div>
  );
};

export default core;
